import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Card = styled.div`
  max-width: 285px !important;
  height: 440px;
  flex-shrink: 0;
  position: relative;
  transition-property: transform;
  border-radius: 10px;
  transition: all ease-out 0.5s;
  background: #fff;
  overflow: hidden;
  text-decoration: none;
  text-align: center;
  /* box-shadow: 4px 4px 10px #d9d9d9, -4px -4px 10px #fff; */
  margin: 0 10px;
  display: grid;
  cursor: pointer;
  @media (max-width: 767px) {
    margin: 0 auto;
  }
  > div {
    z-index: 0;
    margin: 4px;
    background: #fff;
    padding: 0.5em 0;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
  h4 {
    border-top: 1px solid #f3f3f3;
    padding: 7.5px;
    font-size: 15px;
    margin: 7.5px 4px 0;
    color: ${COLORS.BLACK};
  }
  p {
    color: #000;
    font-weight: 700;
    font-size: 15px;
    margin-top: 0;
  }
  img {
    height: 250px;
    width: 100%;
    object-fit: contain;
    margin: 0 auto;
    background-color: ${COLORS.WHITE};
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
  }
  &.active {
    cursor: pointer;
    background: #272742;
    outline: none;
    h4,
    p {
      color: ${COLORS.WHITE};
    }
  }
`;
const DetailSection = styled.div`
  margin-top: 40px;
  padding: 1em 0;
  display: grid;
  grid-gap: 20px;
  padding: 1em;
  background: #fff;
  border-radius: 4px;
  grid-template-columns: 1fr 1fr;
`;
const Description = styled.div`
  border-right: 1px solid #f3f3f3;
  font-size: 14px;
  color: ${COLORS.BLACK};
  h4 {
    font-size: 19px;
    margin-top: 0;
  }
  p {
    margin: 6px 0;
    span {
      font-size: 14px !important;
    }
  }
`;

const Size = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fill, minmax(60px, auto));
  > div {
    display: grid;
    cursor: pointer;
    justify-items: center;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-weight: 700;
    color: #333;
    padding: 0.25em;
  }
`;

const Color = styled.div`
  color: ${COLORS.BLACK};
  h4 {
    font-size: 19px;
  }
`;

const ColorWrapper = styled.div`
  display: grid;
  grid-gap: 5px;
  grid-template-columns: repeat(auto-fit, minmax(30px, 30px));
  > div {
    width: 100%;
    height: 30px;
  }
`;

const CardWrapper = styled.div`
  outline: none;
`;

export {
  Card,
  DetailSection,
  Description,
  Size,
  Color,
  ColorWrapper,
  CardWrapper,
};
